import { render, staticRenderFns } from "./ratioSelection_new.vue?vue&type=template&id=08bebf8a&scoped=true"
import script from "./ratioSelection_new.vue?vue&type=script&lang=js"
export * from "./ratioSelection_new.vue?vue&type=script&lang=js"
import style0 from "./ratioSelection_new.vue?vue&type=style&index=0&id=08bebf8a&prod&lang=stylus&scoped=true"
import style1 from "./ratioSelection_new.vue?vue&type=style&index=1&id=08bebf8a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bebf8a",
  null
  
)

export default component.exports